module.exports = __webpack_public_path__ + "img/regioneer.86e882cb.jpeg";